export default {
  data() {
    return {
      props: {
        tag: '',
        width: '325px',
        zIndex: 'auto',
        maxWidth: '450px',
        hideDesktopOrder: 0,
        hideMobileOrder: 0
      },
      sidebar: '2',
      internal_config: {
        version: 'v1.2',
        width: '325px',
        height: '850px',
        maxWidth: '450px',
        zIndex: 'auto',
        showDesktop: true,
        showMobile: true,
        hideDesktopOrder: 0,
        hideMobileOrder: 0,
        sellableHash: '',
        type: '',
        language: '',
        theme: {},
        texts: {},
        steps: 2
      },
      name: 'checkout',
      assets: {
        mount: null,
        js: null,
        i18n: null
      }
    };
  }
};



// WEBPACK FOOTER //
// ./src/components/editor/apps/Checkout/Model.js